import {DIRECTION_NAME} from "../../../constants";

export const getPassengerDiscountOptions = (passenger,directionType,foundReturnDiscounts,foundDiscounts) => {
    if (directionType === DIRECTION_NAME[0] && passenger?.haveOppositeDirection) {
        return foundReturnDiscounts;
    }
    if (directionType === DIRECTION_NAME[1] && passenger?.haveOppositeDirection) {
        return foundDiscounts;
    }
    return directionType === DIRECTION_NAME[1]
        ? foundReturnDiscounts
        : foundDiscounts;
};
